import Tag from "../core/interfaces/Tag";
import ProviderFactory from "../core/ProviderFactory";
import {
  CommunityProviderType,
  ProviderConfiguration,
  VanillaProvider,
} from "../core/types/Provider";
import { isMode } from "../core/utilities";

export default abstract class IdeaModel {
  private static provider: VanillaProvider = ProviderFactory.create(
    CommunityProviderType.Default,
    isMode("development")
      ? ProviderConfiguration.local
      : ProviderConfiguration.vanilla
  );
  private static ideaStatusesCache: Array<Tag> = null;

  public static getIdeaStatusesCached(): Promise<Array<Tag>> {
    return new Promise((resolve, reject) => {
      if (IdeaModel.ideaStatusesCache === null) {
        const filter = ["type=Status"];
        IdeaModel.provider
          .getTags(filter)
          .then((vanillaIdeaStatuses) => {
            const availableIdeaStatuses = [
              "Submitted",
              "More Information Requested",
              "Under Oracle Review",
              "Option for Future Release",
              "Planned",
              "Delivered",
              "Current Capability",
              "Duplicate",
              "Declined",
              "Archived",
            ];
            const ideaStatuses = availableIdeaStatuses.map((ideaStatus) => {
              const statusFound = vanillaIdeaStatuses.find(
                (tag) => tag.name === ideaStatus
              );
              if (statusFound) {
                return {
                  id: statusFound.tagID,
                  name: statusFound.name,
                  urlCode: statusFound.urlCode,
                };
              } else {
                return {
                  id: 0,
                  name: ideaStatus + " (doesn't exist in node)",
                  urlCode: ideaStatus,
                };
              }
            });
            resolve(ideaStatuses);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        resolve(IdeaModel.ideaStatusesCache);
      }
    });
  }
}
